"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ColorTransformDestinationBase = void 0;
var tslib_1 = require("tslib");
var constants_1 = require("@devexpress/utils/lib/constants");
var destination_1 = require("../../../destination");
var ColorTransformDestinationBase = (function (_super) {
    tslib_1.__extends(ColorTransformDestinationBase, _super);
    function ColorTransformDestinationBase(data, color) {
        var _this = _super.call(this, data) || this;
        _this.color = color;
        return _this;
    }
    ColorTransformDestinationBase.prototype.getIntegerValue = function (reader) {
        return this.data.readerHelper.getIntegerValue(reader, 'val', constants_1.Constants.MIN_SAFE_INTEGER);
    };
    return ColorTransformDestinationBase;
}(destination_1.LeafElementDestination));
exports.ColorTransformDestinationBase = ColorTransformDestinationBase;
